module.exports = __webpack_public_path__ + "static/assets/b4c3606f4126d3226d96d31e36fff84d.svg";